module.exports = __webpack_public_path__ + "img/gray-blot.751ca394.svg";